import { render, staticRenderFns } from "./feedback.vue?vue&type=template&id=a58865e6"
import script from "./feedback.vue?vue&type=script&lang=js"
export * from "./feedback.vue?vue&type=script&lang=js"
import style0 from "./feedback.vue?vue&type=style&index=0&id=a58865e6&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/pppppat/Documents/GitHub/sp-web-v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a58865e6')) {
      api.createRecord('a58865e6', component.options)
    } else {
      api.reload('a58865e6', component.options)
    }
    module.hot.accept("./feedback.vue?vue&type=template&id=a58865e6", function () {
      api.rerender('a58865e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/carInsuranceSystem/applyInfoManagement/applyInfo/feedback.vue"
export default component.exports